import React from 'react';
import RebateInfo from './components/RebateInfo';

import './MerchantInfo.scss';

function MerchantInfo({
  merchantName, displayRate, currency, merchantImg,
}) {
  return (
    <div className="mn_instoreMerchantInfo">
      {merchantImg ? <img src={merchantImg} alt={merchantName} /> :
      <p className="mn_merchantName">{merchantName}</p>}
      <div className="mn_rebateWrap">
        <p className="mn_linkOfferText">Link offer and</p>
        <RebateInfo displayRate={displayRate} currency={currency} />
      </div>
    </div>
  );
}

export default MerchantInfo;
